import { getIsMobileOS } from 'src/utils/window'

export type TooltipTrigger = 'click' | 'focus' | 'hover'

const HoverUnavailableMediaQuery = '(hover: none)'

/** Resolves hover to click on mobile OS and touch-first desktop; explicit click/focus are unchanged. */
export const getEffectiveTooltipTrigger = (trigger: TooltipTrigger = 'hover'): TooltipTrigger => {
  if (trigger === 'click' || trigger === 'focus') {
    return trigger
  }

  if (typeof window === 'undefined') {
    return 'hover'
  }

  const prefersClick = getIsMobileOS() || window.matchMedia(HoverUnavailableMediaQuery).matches

  return prefersClick ? 'click' : 'hover'
}
